import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCountry = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "country",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2610_6126",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 16,
				height: 16,
				fill: "#D9D9D9",
				style: {
					fill: "#D9D9D9",
					fill: "color(display-p3 0.8510 0.8510 0.8510)",
					fillOpacity: 1
				}
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2610_6126)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "public",
				d: "M8.00476 14.4C7.12388 14.4 6.29454 14.2333 5.51676 13.9C4.73899 13.5667 4.05843 13.1083 3.4751 12.525C2.89176 11.9417 2.43343 11.2613 2.1001 10.484C1.76676 9.70667 1.6001 8.87611 1.6001 7.99233C1.6001 7.10855 1.76676 6.28055 2.1001 5.50833C2.43343 4.73611 2.89176 4.05833 3.4751 3.475C4.05843 2.89167 4.73876 2.43333 5.5161 2.1C6.29343 1.76667 7.12399 1.6 8.00776 1.6C8.89154 1.6 9.71954 1.76667 10.4918 2.1C11.264 2.43333 11.9418 2.89167 12.5251 3.475C13.1084 4.05833 13.5668 4.73733 13.9001 5.512C14.2334 6.28678 14.4001 7.11455 14.4001 7.99533C14.4001 8.87622 14.2334 9.70555 13.9001 10.4833C13.5668 11.2611 13.1084 11.9417 12.5251 12.525C11.9418 13.1083 11.2628 13.5667 10.4881 13.9C9.71332 14.2333 8.88554 14.4 8.00476 14.4ZM7.2001 13.1333V12C6.97788 12 6.78899 11.9217 6.63343 11.765C6.47788 11.6083 6.4001 11.42 6.4001 11.2V10.4L2.91676 6.91667C2.87232 7.12778 2.84176 7.32222 2.8251 7.5C2.80843 7.67778 2.8001 7.84444 2.8001 8C2.8001 9.27778 3.21399 10.4056 4.04176 11.3833C4.86954 12.3611 5.92232 12.9444 7.2001 13.1333ZM12.0001 11.3167C12.2001 11.0833 12.3751 10.8389 12.5251 10.5833C12.6751 10.3278 12.7993 10.0581 12.8978 9.77417C12.9962 9.49017 13.0712 9.1985 13.1228 8.89917C13.1743 8.59972 13.2001 8.3 13.2001 8C13.2001 6.94878 12.9112 5.98878 12.3334 5.12C11.7557 4.25111 10.9779 3.61111 10.0001 3.2V3.6C10.0001 3.93 9.8826 4.2125 9.6476 4.4475C9.4126 4.6825 9.1301 4.8 8.8001 4.8H7.2001V5.6C7.2001 5.82667 7.12343 6.01667 6.9701 6.17C6.81676 6.32333 6.62676 6.4 6.4001 6.4H5.6001V8H9.6001C9.82676 8 10.0168 8.07667 10.1701 8.23C10.3234 8.38333 10.4001 8.57333 10.4001 8.8V10.4H11.0834C11.339 10.4 11.5557 10.4889 11.7334 10.6667C11.9112 10.8444 12.0001 11.0611 12.0001 11.3167Z",
				fill: "#696B79",
				style: {
					fill: "#696B79",
					fill: "color(display-p3 0.4118 0.4196 0.4745)",
					fillOpacity: 1
				}
			})
		})]
	})
});
export default SvgCountry;
